import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActionEvent } from 'projects/shared-lib/src/models/common.model';


@Component({
  selector: 'lib-file-item',
  templateUrl: './file-item.component.html',
  styleUrls: ['./file-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileItemComponent {
  private _file: any;
  get file(): any {return this._file;};
  @Input() set file(newFile: any) {
    this._file = newFile;
    this.refreshControl();
  }
  @Output() action =new EventEmitter<ActionEvent>();
  @Input() canEdit: boolean = true;
  @Input() canView: boolean = true;
  @Input() canDelete: boolean = true;
  
  isEdit: boolean = false;

  formGroup = this.fb.group({
    titleControl : ['', Validators.required]
  })

  iconFile="report_problem"


  constructor(
    private fb: FormBuilder

  ) { }


  /**
   * Refresh the control with the new data only if is not editting
   */
  private refreshControl(){
    if (this.isEdit) return;
    this.formGroup.get('titleControl').setValue(this._file.displayName ?? this._file.name);
  }

  /**
   * //calls to open the file
   */
  viewFile(){this.action.emit({type:'open', payload:{file:this._file}})}
  /**
   * Displays an Input to modify the text, then it saves
   */
  editName(){this.isEdit=true;}

  /**
   * Call a delete event
   */
  deleteItem(){this.action.emit({type:'delete', payload:{file:this._file}})}

  /**
   * Saves the information modified in the title
   */
  saveName(){

    let file = {...this.file};
    file.displayName = this.formGroup.get('titleControl').value;
    this._file.displayName = file.displayName;

    this.isEdit=false;
    this.refreshControl();
    this.action.emit({type:'edit', payload:{file:this._file}})
  }

  /**
   * Restores the alst information
   */
  cancelEdit(){
    this.isEdit=false;
    this.refreshControl()
  }

}


